/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutableRefObject } from "react";
import { ReadonlyURLSearchParams } from "next/navigation";
import { DeepPartialObject, SearchXState } from "@costar-search-x/core";

export type SearchXStateType<C> = SearchXState<
  C, //crit
  string[], //favs
  never, //alerts
  any, //result item (intentionally any, as it is unused)
  any, // counts (intentionally any, as it is unused)
  any, //list item (intentionally any, as it is unused)
  never, // placard item
  never ///gallery item
>;

export const handleSearchXCriteriaChange = <
  C,
  U extends Record<string, string | number>
>({
  criteria,
  searchParams,
  searchParamsAsStringRef,
  getCriteriaParams,
  page,
}: {
  criteria: C | undefined;
  searchParams: ReadonlyURLSearchParams;
  searchParamsAsStringRef: MutableRefObject<string>;
  getCriteriaParams: (criteria: C | undefined) => U;
  page: number | undefined;
}) => {
  const criteriaAsUrlParams = getCriteriaParams(criteria);

  const urlPageNumber = searchParams?.get("page") ?? 1;

  const isPageNumberUpdated =
    page !== undefined && page !== Number(urlPageNumber);
  if (
    Object.keys(criteriaAsUrlParams).some(
      (key) => criteriaAsUrlParams[key] != searchParams?.get(key)
    ) ||
    isPageNumberUpdated
  ) {
    const newSearchParams = new URLSearchParams(
      JSON.parse(JSON.stringify(criteriaAsUrlParams))
    );
    if (isPageNumberUpdated && page !== 1) {
      newSearchParams.set("page", page?.toString());
    }
    // need to sort to create unique string for comparison,
    const newSearchParams_ = new URLSearchParams(newSearchParams?.toString());
    newSearchParams_.sort();
    searchParamsAsStringRef.current = newSearchParams_.toString();
    if (!isPageNumberUpdated) {
      window.history.pushState(null, "", `?${newSearchParams.toString()}`);
      //TODO: double-check, do we need this?
      document.documentElement.scrollTop = 0;
    } else {
      window.history.pushState(null, "", `?${newSearchParams.toString()}`);
    }
  }
};

export const handleSearchParamsChange = <
  C,
  U extends Record<string, string | number>
>({
  baseCriteria,
  searchParams,
  convertUrlToCriteria,
  searchXState,
}: {
  baseCriteria: DeepPartialObject<C>;
  searchParams: ReadonlyURLSearchParams;
  convertUrlToCriteria: (
    key: keyof U,
    value: string,
    criteria: DeepPartialObject<C>
  ) => DeepPartialObject<C>;
  searchXState: SearchXStateType<C> | undefined;
}) => {
  // let updatedCriteria: DeepPartialObject<C> = structuredClone(baseCriteria);
  let updatedCriteria: DeepPartialObject<C> = JSON.parse(
    JSON.stringify(baseCriteria)
  );
  searchParams?.forEach((v, k) => {
    updatedCriteria = convertUrlToCriteria(k as keyof U, v, updatedCriteria);
  });

  searchXState?.searchActions?.updateCriteria(updatedCriteria);
  searchXState?.searchActions?.setPageNumber(
    Number(searchParams?.get("page")) || 1
  );
};

export const stringToNumberArray = (value: string) => {
  if (value.length === 0) {
    return [];
  } else {
    return value.replace(/, +/g, ",").split(",").map(Number);
  }
};
